import styles from './styles.module.scss';

import clsx from 'clsx';
import React, { FC } from 'react';

import { useMenu } from 'components/MenuContext/MenuContext';
import { Category } from 'olo-service';

import { Header } from 'components/PageLayout/Header';
import { CartWidget } from 'routes/Menu/MenuHeader/CartWidget';
import { TableOfContent } from 'routes/Menu/MenuHeader/TableOfContent';

export const MenuHeader: FC<{ hideCategories?: boolean }> = ({ hideCategories }) => {
  const { menu, loading, error } = useMenu();

  const categories: Category[] = (!loading && !error && menu?.categories) || [];
  const showCategoriesTOC = categories.length > 1;

  return (
    <Header to="~" className={clsx(styles.header, showCategoriesTOC && styles.secondRow)}>
      <div className={styles.navContainer}>
        {!hideCategories && showCategoriesTOC && <TableOfContent categories={categories} />}
        <div className={styles.cartContainer}> {/*This container is here so we can position the cart relative to it*/}
          <CartWidget className={styles.cartWidget} />
        </div>
      </div>
    </Header>
  );
};
